module.exports = __webpack_public_path__ + "static/media/home-vertical-slide-portfolio-slide-01-bg.ee554567.jpg";